<template>
    <tr class="h-auto" :class="{'bg-gray-50' : isArchived}">
        <td class="px-4 py-2 text-sm font-medium" :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            <div class="flex items-center gap-2 whitespace-nowrap">
                {{ lease.start_date | date }} {{ lease.end_date ? "to " + $options.filters.date(lease.end_date) : " - Month to Month" }}
            </div>
            <div v-if="lease.contacts && lease.contacts.length > 0">
                <ul class="text-gray-400 font-normal mt-1">
                    <li v-for="contact in lease.contacts" class="flex items-center gap-2">
                        <icon-user class="w-4 h-4 inline-block" :class="[contact.pivot.role === 'tenant' ? 'text-indigo-600' : 'text-green-600']"
                                   :filled="contact.pivot.primary == 1"></icon-user>
                        <span class="font-medium" :class="[contact.pivot.role === 'tenant' ? 'text-indigo-600' : 'text-green-600']">{{
                                contact.pivot.role | capitalize
                            }}</span>
                        <span>{{ contact.full_name }}</span>
                    </li>
                </ul>
            </div>
            <div v-if="currentTailwindBreakpoint < 2" class="flex mt-2 cursor-pointer select-none"
                 @click.prevent="goToRamsLease(lease.id)">
                <span class="border border-gray-300 rounded-md bg-gray-100 text-gray-900 text-xs px-1">
                    {{ lease.secondary_identifier_id }}
                </span>
            </div>
        </td>
        <td class="group whitespace-nowrap py-2 px-3 text-sm font-bold hidden md:table-cell"
            :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            <div class="hidden md:table-cell">
                <div class="flex items-center flex-nowrap justify-start gap-2 font-medium cursor-pointer"
                     @click.prevent="goToRamsLease(lease.id)">
                    <span class="border border-gray-300 rounded-md bg-gray-100 text-gray-900 text-xs px-1">
                        {{ lease.secondary_identifier_id }}
                    </span>
                </div>
            </div>
        </td>
        <td class="whitespace-nowrap px-3 py-2 text-sm font-normal">
            <div class="flex items-center flex-nowrap justify-end gap-2 font-normal"
                 :class="[isArchived ? 'text-gray-400' : 'text-gray-900 font-normal']">
                {{ lease.rent | money }}
            </div>
            <!--Only show deposit here on small screens-->
            <div v-if="currentTailwindBreakpoint < 2"
                 class="flex items-center flex-nowrap justify-end gap-2 font-normal"
                 :class="[isArchived ? 'text-gray-400' : 'text-indigo-600 font-normal']">
                {{ lease.deposit | money }}
            </div>
        </td>
        <td class="py-2 px-3 text-sm font-normal hidden md:table-cell text-right whitespace-nowrap"
            :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            {{ lease.deposit | money }}
        </td>
    </tr>
</template>

<script>
export default {
    name: "lease-list-row-for-asset",
    props: ["lease"],
    computed: {
        isArchived () {
            return this.lease.archived_at !== null;
        },
        isHovered () {
            return false;
        },
    },
    methods: {
        goToRamsLease () {
            const domain = window.location.hostname.includes("secure.redrabbit.zone") ? "https://rams.weconnectu.co.za" : "https://rams.rebaseventures.com";
            window.open(`${domain}/leases/${this.lease.group_external_id}`, "_blank");
        },
        getStatusBadgeClasses (status) {
            if (this.isArchived) {
                return "bg-gray-100 text-gray-400";
            }

            switch (status) {
                case "uploaded":
                    return "bg-yellow-100 text-yellow-600";
                case "completed":
                    return "bg-green-100 text-green-600";
                default:
                    return "bg-indigo-100 text-indigo-600";
            }
        },
    }
};
</script>

<style scoped>

</style>
